export const EXTERNAL_CHANNEL_LABEL = 'Broker';

export const MAX_BADGE_LABEL_LENGTH = 4;
